// extracted by mini-css-extract-plugin
export var card = "_je-5";
export var cardSelected = "_je-4";
export var image = "_je-3";
export var modal = "_je-0";
export var modalContent = "_je-1";
export var table = "_je-2";